import { propertyStatusList } from "../../addBusiness/constanst/FormsBusinessDTO";
export var formAddBusiness = {
    ownerName: "",
    ownerIdNumber: "",
    propertyTypeId: "",
    businessShift: "",
    sameAddress: true,
    Province: "",
    Town: "",
    Sector: "",
    typeConstruction: "",
    propertyAddress: "",
    coverageNotes: "",
    typeProperty: "",
    buildingValue: "",
    merchandiseValue: "",
    furnitureValue: "",
    totalInsuredValue: "",
    insuredProperty: "",
    damageBackup: "",
};
export var FormsBusinessDTO = {
    section1Title: "Datos del negocio",
    section2Title: "Ubicación de la propiedad",
    section3Title: "Valores asegurados",
    labelButtonBack: "Cerrar",
    disablePropertyType: true,
    isEditMode: false,
    showBtnCalcRate: false,
    showBtnNext: false,
    showResumen: false,
    heightForm: "100%",
    ProvinceList: [],
    TownList: [],
    SectorList: [],
    propertyTypeList: [],
    propertyStatusList: propertyStatusList,
    businessShiftList: [],
    typeConstructionList: [],
    damageBackup: "",
    insuredProperty: "",
    onNext: function () { },
};
